var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidityBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7819 8.37128L10.0531 2.43353C9.999 2.3576 9.92753 2.2957 9.84465 2.25298C9.76178 2.21027 9.66989 2.18799 9.57666 2.18799C9.48343 2.18799 9.39154 2.21027 9.30867 2.25298C9.22579 2.2957 9.15432 2.3576 9.10022 2.43353L5.35454 8.39997C4.83459 9.23935 4.54476 10.2008 4.51416 11.1877C4.51416 12.5304 5.04753 13.818 5.99693 14.7674C6.94633 15.7168 8.234 16.2502 9.57666 16.2502C10.9193 16.2502 12.207 15.7168 13.1564 14.7674C14.1058 13.818 14.6392 12.5304 14.6392 11.1877C14.6069 10.1897 14.3111 9.21802 13.7819 8.37128ZM9.57666 15.1252C8.53283 15.1237 7.53217 14.7084 6.79407 13.9703C6.05597 13.2322 5.64065 12.2316 5.63916 11.1877C5.66963 10.4012 5.90587 9.63645 6.32429 8.96978L6.85022 8.13165L12.5168 13.7983C12.1487 14.2152 11.6963 14.5491 11.1894 14.7779C10.6825 15.0068 10.1328 15.1248 9.57666 15.1252Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityBlack);
export default __webpack_public_path__ + "static/media/humidity_black.31647bb3ccd79b6bcd12146fb71e75f8.svg";
export { ForwardRef as ReactComponent };